var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.725,
    height: 13.719,
    viewBox: "0 0 13.725 13.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(0.001 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7683",
    "data-name": "Path 7683",
    className: "cls-1",
    d: "M258.746,108.991a2.542,2.542,0,0,0-4.338-1.8l-.75.75-.885-.885-.938.938.885.885-3,3a2.418,2.418,0,0,0-.712,1.719v1.646l-1.159,1.161.938.938,1.159-1.159H251.6a2.418,2.418,0,0,0,1.721-.712l3-3,.885.885.938-.938-.885-.885.75-.75h0a2.524,2.524,0,0,0,.746-1.8Zm-6.366,5.541a1.106,1.106,0,0,1-.781.323H250.34V113.6a1.1,1.1,0,0,1,.323-.783l3-2.993,1.717,1.717Zm4.683-4.685-.75.752-1.717-1.717.75-.75a1.214,1.214,0,1,1,1.717,1.717Z",
    transform: "translate(-245.031 -106.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7684",
    "data-name": "Path 7684",
    className: "cls-1",
    d: "M178.831,141.63h7.964a2.433,2.433,0,0,0,2.433-2.433v-2.433H187.9V139.2a1.106,1.106,0,0,1-1.106,1.106H178.83a1.106,1.106,0,0,1-1.106-1.106v-7.964a1.106,1.106,0,0,1,1.106-1.106h2.433V128.8H178.83a2.433,2.433,0,0,0-2.433,2.433V139.2a2.433,2.433,0,0,0,2.433,2.433Z",
    transform: "translate(-176.398 -127.917)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/Color.828687165d2fa80ffed555f3d3f497df.svg";
export { ForwardRef as ReactComponent };